import { graphql } from '@/gql';
import type { TransferRideCreditsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const transferRideCredits = async ({ fromCallerId, toCallerId, amount, notes }: TransferRideCreditsMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      fromCallerId,
      toCallerId,
      amount,
      notes,
    },
    mutation: graphql(`
      mutation TransferRideCredits($notes: String!, $amount: Float!, $toCallerId: String!, $fromCallerId: String!) {
        transferRideCredits(notes: $notes, amount: $amount, toCallerId: $toCallerId, fromCallerId: $fromCallerId)
      }
    `),
  });

  return response.data?.transferRideCredits ?? false;
};
